// eslint-disable-next-line import/prefer-default-export
export function getItemsPerPageFromLS() {
  return localStorage.getItem('itemsPerPage') ? +localStorage.getItem('itemsPerPage') : 10
}

export function getPageFromLS() {
  return localStorage.getItem('page') ? +localStorage.getItem('page') : 1
}
